<template>
    <v-card v-if="profile">
        <v-list>
            <Profile :profile="profile" :callback="logout" />
        </v-list>

        <v-divider></v-divider>

        <v-list>
            <v-list-tile>
                <v-list-tile-action>
                    
                </v-list-tile-action>
                <v-list-tile-title>Enable messages</v-list-tile-title>
            </v-list-tile>
        </v-list>
    </v-card>
    <v-card v-else>
        <v-card-text ref="auth">
            Auth
        </v-card-text>
    </v-card>
</template>

<script>
import { firestore, ui, uiConfig, auth } from '@/firebase'
import Profile from '@/components/user/Profile'

export default {
    data () {
        return {
            profile: null
        }
    },
    mounted () {
        if (auth.currentUser) {
            this.get_profile(auth.currentUser)
        } else {
            this.start_ui()
        }
    },
    methods: {
        start_ui() {
            console.log("starting")
            const el = document.getElementById("firebaseui-auth-container").cloneNode(true)
            this.$refs.auth.appendChild(el)
            ui.start('#firebaseui-auth-container', {
                ...uiConfig,
                callbacks: {
                    signInSuccessWithAuthResult: (res) => { this.get_profile(res.user) }
                }
            })
        },
        get_profile(user) {
            this.profile = {
                name: user.displayName,
                picture: user.photoURL,
                email: user.email
            }
        },
        async logout () {
            await auth.signOut()
            this.profile = null
            this.start_ui()
        },
    },
    components: {
        Profile
    }
}
</script>
